import * as IoC from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Common from '../common'
import * as Projection from '../projection'
import * as Serialization from '../serialization'

export const sectionStateCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(Common.SectionSuspendDataStateStore).toSelf().inSingletonScope();
  bind(StateSerializationPluginSymbol).to(Serialization.SectionStateProtobufSerializer)

  // projections
  bind(Projection.SectionStateProjection).toSelf().inSingletonScope();
  bind(Projection.SessionTimeProjection).toSelf().inSingletonScope();
})
